import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '@heroui/react';
import { Icon } from '@iconify/react';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="text-center max-w-md">
        <div className="text-6xl font-bold text-gray-900 mb-4">404</div>
        <h1 className="text-2xl font-semibold mb-2">{t('pageNotFound')}</h1>
        <p className="text-gray-500 mb-6">{t('pageNotFoundMessage')}</p>
        <Button
          as={Link}
          to="/dashboard"
          color="primary"
          startContent={<Icon icon="lucide:home" width={20} />}
        >
          {t('backToDashboard')}
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
